/* eslint-disable no-unused-vars */
import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { httpRequest } from '@hc/utils/axios';
import { toast } from 'react-hot-toast';
import create from 'zustand';

export const useMasterDrugCategory = create((set, get) => ({
  masterDrugCategoryData: [],
  loading: null,
  error: null,
  getMasterDrugCategoryData: async () => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query

      const { data, status } = await queryClient.fetchQuery({
        queryKey: ['masterDrugCategory'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-drug-category`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      const masterDrugCategoryDataCopy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          masterDrugCategoryDataCopy.push({
            value: val?.id ?? '',
            name: val?.drug_category_name ?? '',
            label: val?.drug_category_name ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        masterDrugCategoryData: masterDrugCategoryDataCopy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
